if (!window.__CUSTOM_QTY_HANDLER_ATTACHED__) {
  window.__CUSTOM_QTY_HANDLER_ATTACHED__ = true;

  document.addEventListener("click", (event) => {
    if (event.target.matches(".qty-btn.plus")) {
      const form = event.target.closest(".custom-add-to-cart-form");
      const input = form?.querySelector(".qty-input");

      if (input) {
        const step = parseInt(input.step || 1, 10);
        // const step = parseInt(input.dataset.step || 1, 10);
        const current = parseInt(input.value || "1", 10);
        const newValue = current + step;
        input.value = newValue >= 1 ? newValue : 1;
      }
    }

    if (event.target.matches(".qty-btn.minus")) {
      const form = event.target.closest(".custom-add-to-cart-form");
      const input = form?.querySelector(".qty-input");
      const step = input.step || 1;
      // const step = parseInt(input.dataset.step || 1, 10);

      if (input) {
        const current = parseInt(input.value || "1", 10);
        if (current > 1) {
          const newValue = current - step;
          input.value = newValue >= 1 ? newValue : step;
        }
      }
    }
  });

  // Handle narrow width stacking for custom-quantity-add
  function observeQuantityAddElements() {
    const quantityAddElements = document.querySelectorAll(
      ".custom-quantity-add"
    );

    // Get threshold from theme settings (default to 175px)
    const threshold = parseInt(window.quantityAddStackThreshold || "175", 10);

    quantityAddElements.forEach((element) => {
      // Skip if already observed
      if (element.dataset.observed === "true") return;
      element.dataset.observed = "true";

      const resizeObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
          const width = entry.contentRect.width;
          if (width <= threshold) {
            element.classList.add("narrow-width");
          } else {
            element.classList.remove("narrow-width");
          }
        }
      });

      resizeObserver.observe(element);
    });
  }

  // Run on DOMContentLoaded and after dynamic content loads
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", observeQuantityAddElements);
  } else {
    observeQuantityAddElements();
  }

  // Also observe when new content is added (for AJAX-loaded products)
  const mutationObserver = new MutationObserver(() => {
    observeQuantityAddElements();
  });

  mutationObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
}
